package com.shadowings.gero.domain.model

import org.jetbrains.compose.resources.StringResource

data class Option(
    val text: QuizText,
    val correct: Boolean
) {
    // Helper constructors for StringResource and String
    constructor(text: StringResource, correct: Boolean) : this(QuizText.Resource(text), correct)
    constructor(text: String, correct: Boolean) : this(QuizText.Plain(text), correct)
}

